import { render, staticRenderFns } from "./AddLeadResultItemButtons.vue?vue&type=template&id=b8421404&"
import script from "./AddLeadResultItemButtons.vue?vue&type=script&lang=js&"
export * from "./AddLeadResultItemButtons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports